// @flow strict

import * as React from 'react';

type PropTypes = {|
  dataSrc: '',
  dataSrcSet: '',
  dataSizes: '',
  dataTitle: '',
  dataIntro: '',
|};

export const HeroBase = (props: { ...PropTypes }) => {
  return (
    <div className="devotion-homepage-hero">
      <div className="background">
        <img
          data-src={props.dataSrc}
          data-srcset={props.dataSrcSet}
          data-sizes={props.dataSizes}
          alt=""
          className="lazyload"
        />
      </div>
      <div className="foreground">
        <div className="wrapper">
          <h1>{props.dataTitle}</h1>
          <div className="intro">{props.dataIntro}</div>
        </div>
      </div>
    </div>
  );
};
const Hero = (props: PropTypes) => <HeroBase {...props} />;

export default Hero;
